import { gql } from '@apollo/client';
// Fragments
import { AmaFields, AmaRequestFields, AmaSubmitFields } from './fragments';

export const CREATE_AMAS = gql`
  mutation CreateAmas($input: AmasCreateInput!) {
    createAmas(input: $input) {
      ...AmaFields
    }
  }
  ${AmaFields}
`;

export const EDIT_AMAS = gql`
  mutation EditAmas($input: AmasEditInput!) {
    editAmas(input: $input) {
      ...AmaFields
    }
  }
  ${AmaFields}
`;

export const ACCEPT_AMA_REQUEST = gql`
  mutation AcceptAmaRequest($id: String!) {
    acceptAmaRequest(id: $id) {
      ...AmaRequestFields
    }
  }
  ${AmaRequestFields}
`;

export const DECLINE_AMA_REQUEST = gql`
  mutation DeclineAmaRequest($input: AmaRequestDeclineInput!) {
    declineAmaRequest(input: $input) {
      ...AmaRequestFields
    }
  }
  ${AmaRequestFields}
`;

export const CREATE_AMA_REQUEST = gql`
  mutation CreateAmaRequest($input: AmaRequestCreateInput!) {
    createAmaRequest(input: $input) {
      stripeIntentID
      ...AmaRequestFields
    }
  }
  ${AmaRequestFields}
`;

export const CREATE_AMA_REQUEST_VIDEO_PRESIGNED_URL = gql`
  mutation CreateAmaRequestVideoPresignedUrl(
    $input: AmaRequestCreatePresignedUrlInput!
  ) {
    createAmaRequestVideoPresignedUrl(input: $input) {
      fields
      key
      url
    }
  }
`;

export const CREATE_AMA_PRESIGNED_URL = gql`
  mutation CreateAmaPresignedUrl {
    createAmaPresignedUrl {
      fields
      key
      url
    }
  }
`;

export const SUBMIT_AMA_REQUEST_VIDEO = gql`
  mutation SubmitAmaRequestVideo($input: AmaRequestSubmitVideoInput!) {
    submitAmaRequestVideo(input: $input) {
      ...AmaSubmitFields
    }
  }
  ${AmaSubmitFields}
`;
